const Colors = {
    Dark: '#000000',
    white: '#FAFAFA',
    fullWhite: '#FFFFFF',
    partialWhite: '#fff',
    white_40: '#FAFAFA66',
    white_30: 'rgba(250, 250, 250, 0.3)',
    white_70: 'rgba(255, 255, 255, 0.7)',
    white2: '#fefefe',
    black: '#000',
    black_70: 'rgba(0,0,0,0.70)',
    black_50: 'rgba(0, 0, 0, 0.5)',
    blackGrey: '#181536',
    grey: '#BFBFBF',
    grey2: '#333538',
    dark: '#303030',
    errorColor: '#f44336',
    errorBackground: '#FA443A',
    errorBackgroundDark: '#2e2e2e',
    shark: '#282a2c',
    sharkDark: '#43BE3F',
    shark2: '#222225',
    nevada: '#6c6d6e',
    bush: '#123f21',
    blueShadow: 'rgba(111,110,255,0.50)',
    darkGrey: '#191B1D',
    darkGrey2: '#4F5255',
    green: '#52c54f',
    lightGreen: '#4CA13F',
    darkGreen: '#2E8321',
    nero: '#272727',
    eclipse: '#3D3D3D',
    forestGreen: '#237824',
    bunker: '#212325',
    greySuit: '#8B8B8C',
    lightGrey_006: 'rgba(216, 216, 216, 0.06)',
    lightGrey2: '#72767C',
    lightGrey3: '#4B4C4E',
    lightGrey4: '#2C2E31',
    lightGrey5: '#59598E',
    greyShuttle: '#5F666E',
    greyShuttle_40: 'rgba(95, 102, 110, 0.4)',
    midGrey: '#6C6D6E',
    blackRussian: '#1D1F21',
    cardBackground: '#222225',
    transparent: '#FAFAFA00',
    yellow: '#FFFF00',
    blue: '#98e3dc',
    blue1: '#3E54F1',
    lightBlue: '#70ACC6',
    darkYellow: '#ECC96A',
    lightYellow: '#FBBD05',
    lightOrange: '#E7C29B',
    darkOrange: '#EA6A4A',
    lightDark: '#424242',
    red: 'red',
    red235: '#EB6B6D',
    red1: '#FF4648',
    severityLow: '#d9af3b',
    severityMedium: '#cf7642',
    severityHigh: '#c22f27',
    severityCritical: '#880A03',
    themeGreen: '#282A47',
    darkBlueBg: '#282A47',
    dividerColor: '#7e7b7b',
    greyText: '#B7B7B7',
    screenBottom: '#424040',
    iconBtnBg: '#473E6B',
    graphicsBg: '#323552',
    transparentbg: '#484B65',
    borderbtn: '#5038BC',
    bblue: '#4551EF',
    btnBg:
      'transparent linear-gradient(136deg, #246AFD 0%, #8B19D0 100%) 0% 0% no-repeat padding-box',
    blue3: '#4460A0',
    subtitleColor: '#b7b7b7',
    captionbtn: '#282A42',
    timer: '#FBBD05',
    icon: '#414165',
    forgotpassowrd:"#b4e94d",
    gradient: 'linear-gradient(45deg, #246AFD 30%,#8B19D0 90%)',
    greyselector:"#EDEEF4",
    opdHeader:"#D3DEFC"
  };
  
  export default Colors;
  